import { render, staticRenderFns } from "./PatientControlAvatar.vue?vue&type=template&id=70685cb8&scoped=true&"
import script from "./PatientControlAvatar.vue?vue&type=script&lang=ts&"
export * from "./PatientControlAvatar.vue?vue&type=script&lang=ts&"
import style0 from "./PatientControlAvatar.vue?vue&type=style&index=0&id=70685cb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70685cb8",
  null
  
)

export default component.exports